import { render, staticRenderFns } from "./PartnerPromocodesPage.vue?vue&type=template&id=1f54420b&scoped=true"
import script from "./PartnerPromocodesPage.vue?vue&type=script&lang=js"
export * from "./PartnerPromocodesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f54420b",
  null
  
)

export default component.exports